import { render, staticRenderFns } from "./about-helper-components-3-resource-list.vue?vue&type=template&id=14fb2f62&"
import script from "./about-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"
export * from "./about-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports